<template>
  <div>
    <!-- 有圖片的排版 -->
    <div v-if="spot.img && spot.img.length > 0">
      <div id="spot_card_3" v-if="spot.img.length === 3">
        <b-row>
          <b-col cols="12" md="4" class="" v-for="(image, index) in spot.img" :key="index">
            <div class="spot_img">
            <img :src="'https://tstar888.com/JP2TW/test/vue_jp2tw/src/assets/imageData/'+ image.filename + '.jpg'" class="img-fluid">
          </div>
          </b-col>
          <b-col cols="12" class="spot_intro">
            <h5 class="spot_title">
              <span v-if="!spot.url">{{spot.title}}</span>
              <span v-if="spot.url">
                <a :href="spot.url" target="_blank">{{spot.title}}</a>
              </span>
            </h5>
            <p class="spot_txt">
              {{spot.detail}}
            </p>
          </b-col>
        </b-row>
      </div>
      <div id="spot_card1" v-if="spot.style === 1 && spot.img.length !== 3">
        <b-row>
          <b-col cols="12" md="6" class="spot_img">
            <img :src="'https://tstar888.com/JP2TW/test/vue_jp2tw/src/assets/imageData/'+ spot.img[0].filename + '.jpg'" class="img-fluid">
          </b-col>
          <b-col cols="12" md="6" class="spot_intro">
            <h5 class="spot_title">
              <span v-if="!spot.url">{{spot.title}}</span>
              <span v-if="spot.url">
                <a :href="spot.url" target="_blank">{{spot.title}}</a>
              </span>
            </h5>
            <p class="spot_txt">
              {{spot.detail}}
            </p>
          </b-col>
        </b-row>
        <!-- <hr> -->
      </div>
      <div id="spot_card_2" v-if="spot.style === 2 && spot.img.length !== 3">
        <b-row>
          <b-col cols="12" class="spot_img">
            <img :src="'https://tstar888.com/JP2TW/test/vue_jp2tw/src/assets/imageData/'+ spot.img[0].filename + '.jpg'" class="img-fluid">
          </b-col>
          <b-col cols="12" md="6" class="spot_intro">
            <h5 class="spot_title">
              <span v-if="!spot.url">{{spot.title}}</span>
              <span v-if="spot.url">
                <a :href="spot.url" target="_blank">{{spot.title}}</a>
              </span>
            </h5>
            <p class="spot_txt">
              {{spot.detail}}
            </p>
          </b-col>
          <b-col cols="12" md="6" class="spot_img_md">
            <img :src="'https://tstar888.com/JP2TW/test/vue_jp2tw/src/assets/imageData/'+ spot.img[0].filename + '.jpg'" class="img-fluid">
          </b-col>
        </b-row>
        <!-- <hr> -->
      </div>
    </div>
    <!-- 沒有圖片的排版 -->
    <div v-else class="mt-3">
      <h5 class="spot_title">
        <span v-if="!spot.url">{{spot.title}}</span>
        <span v-if="spot.url">
          <a :href="spot.url" target="_blank">{{spot.title}}</a>
        </span>
      </h5>
      <p class="spot_txt">
        {{spot.detail}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    spot: {
      required: true
    }
  }
}
</script>

<style lang="scss">
#spot_card1 {
  margin: 1rem 0 1.5rem;
  .spot_img {
    margin-bottom: 1.5rem;
    &::before {
      z-index: -1;
      position: absolute;
      display: inline-block;
      content: "";
      // background-color: var(--myblue);
      right: 30px;
      top: 10px;
      width: 90%;
      height: 100%;
      border-radius: 5px;
      // background-image: repeating-linear-gradient(45deg, transparent, transparent 8px, var(--myblue2) 8px, var(--myblue2) 12px);
    }
  }
}
#spot_card_2 {
  margin: 1rem 0 1.5rem;
  .spot_img {
    margin-bottom: 1.5rem;
  }
  .spot_img_md {
    display: none;
  }
  @media (min-width:768px) {
    .day_infoBox {
      margin: 2rem 0;
    }
    .spot_img {
    display: none;
  }
    .spot_img_md {
    display: block;
  }
  }
}
#spot_card_3 {
  margin: 1rem 0 1.5rem;
  // background-color: antiquewhite;
  .spot_img {
    margin-bottom: 1.5rem;
    overflow: hidden;
    position: relative;
    width: 100%;
    padding-top: 75%;
    img {
      position: absolute;
      object-fit: cover;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  // 取消BV的row-15px
  .row {
    margin: 0 -5px;
  }
  .col-md-4 {
    padding: 0 5px;
  }
  @media (min-width:768px) {
    .col-md-4 {
      padding: 0 5px;
    }
  }
}
</style>
